import getPartner from "./modules/get.partner";

export default {
  getPartner
};
